import styled from 'styled-components';

import ProductResolutionImage from 'ggApp/shared/components/resolutionImage/ProductResolutionImage';
import ShimmerEffect from 'ggApp/shared/components/shimmerEffect';
import { Paragraph, TinyParagraph } from 'ggApp/shared/common/Typography';
import NavigationLink from 'ggApp/shared/common/NavigationLink';

const ProductImage = ShimmerEffect(ProductResolutionImage);

const LinkWrap = styled(NavigationLink)`
    display: flex;
    align-items: center;
    position: relative;
    height: 48px;
    border-radius: 8px;
    &:hover {
        background-color: ${({ theme }) => theme.colors["Level 1"]};
    }
`;

const Image = styled(ProductImage)`
    height: 32px;
    width: 32px;
    margin: 0 12px 0 8px;
    flex: 0 0 auto;
`;

const TextWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
`;

const Name = styled(Paragraph)`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 20px;
`;

const Features = styled(TinyParagraph)`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 16px;
    color: ${({ theme }) => theme.colors['Level 4']};
`;

export {
    LinkWrap, Image, TextWrap, Name, Features,
};
